import React from 'react'
import { components, useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import { Box, IconButton, Tooltip, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const {
  button: { CngButton }
} = components

function PartiesInfoTable(props) {
  const { data, onAddPartiesInfo, onEditPartiesInfo, onDeletePartiesInfo, showNotification } = props
  const { translate } = useTranslation(Namespace.UAE_MPCI)

  const partyType = translate(Namespace.UAE_MPCI, UaeMpciKeys.PartiesInfo.PARTY_TYPE)
  const partyName = translate(Namespace.UAE_MPCI, UaeMpciKeys.PartiesInfo.PARTY_NAME)
  const partyId = translate(Namespace.UAE_MPCI, UaeMpciKeys.PartiesInfo.PARTY_ID)
  const country = translate(Namespace.UAE_MPCI, UaeMpciKeys.PartiesInfo.COUNTRY)

  return (
    <Box>
      <Box display="flex" justifyContent="flex-end" mb={1}>
        <CngButton
          color='primary'
          onClick={onAddPartiesInfo}
          size='small'
          startIcon={<FontAwesomeIcon icon={['fal', 'plus']} />}
        >
          Add Party
        </CngButton>
      </Box>
      {data && data.length > 0 && (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{partyType}</TableCell>
              <TableCell>{partyName}</TableCell>
              <TableCell>{partyId}</TableCell>
              <TableCell>{country}</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item.partyType}</TableCell>
                <TableCell>{item.partyName}</TableCell>
                <TableCell>{item.partyId}</TableCell>
                <TableCell>{item.country}</TableCell>
                <TableCell align="right">
                  <Tooltip title="Edit">
                    <IconButton size="small" onClick={() => onEditPartiesInfo(item)}>
                      <FontAwesomeIcon icon={['fal', 'pen']} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton size="small" onClick={() => onDeletePartiesInfo(item)}>
                      <FontAwesomeIcon icon={['fal', 'trash']} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  )
}

export default PartiesInfoTable
